import { render, staticRenderFns } from "./CultureChart.vue?vue&type=template&id=4e0572e6&"
import script from "./CultureChart.vue?vue&type=script&lang=js&"
export * from "./CultureChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports